import { combineLatest, map, Observable } from 'rxjs';

import { ContainerMeasurement } from 'app/features/manual-input-result-registration/models/container-measurement';
import { getScannedCodeNumbersByCodeType } from 'src/app/features/scan-flow/utils/scanned-code-list.utils';

import { mapToScanFlowRegistrationDataCompleteness } from '../scan-flow-labor-registration/scan-flow-labor-registration.selectors';
import { ScanFlowRegistrationData } from '../scan-flow.reducer';
import { mapScanFlowCodesToActivity } from '../scan-flow.selectors';

export const transformScanFlowContainerMeasurementData =
    ({
        registrationData,
        registrationTimestamp,
    }: {
        registrationData: ScanFlowRegistrationData;
        registrationTimestamp: number;
    }) =>
    (store: Observable<object>) =>
        combineLatest([
            store.pipe(mapScanFlowCodesToActivity(registrationData.scannedCodes)),
            store.pipe(mapToScanFlowRegistrationDataCompleteness(registrationData)),
        ]).pipe(
            map(([activity, registrationDataCompleteness]) => {
                if (
                    !registrationData.employeeNumber ||
                    !activity ||
                    registrationDataCompleteness === 'empty'
                ) {
                    return undefined;
                }

                const containerMeasurement: ContainerMeasurement = {
                    employeeNumber: registrationData.employeeNumber,
                    activityNumber: activity.number,
                    amountResult: registrationData.amountResult,
                    containerNumber:
                        getScannedCodeNumbersByCodeType(registrationData.scannedCodes, 'container').at(0) ??
                        0,
                    registrationTimestamp,
                    productBoxRegistrations: registrationData.productBoxRegistrations,
                };

                return containerMeasurement;
            }),
        );
